import { DeserializeFilters } from '../../../hooks/table-pages/use-endpoint-query-parameters'
import qs from 'qs'
import dayjs from 'dayjs'
import FormValues from '../components/filters-form/types/form-values'

export const deserializeFilters: DeserializeFilters = filtersString => {
    const formValues = qs.parse(filtersString) as Partial<FormValues>
    const { clientName, labelName, positionId, month, materialType, stampId, materialWidth } =
        formValues

    const filters: Record<string, any> = {}
    const positionFilters: Record<string, any> = {}

    if (clientName) {
        filters.client = {
            name: { $containsi: clientName },
        }
    }

    if (month) {
        const monthDate = dayjs(month)
        if (monthDate.isValid()) {
            filters.createdAt = {
                $gte: monthDate.startOf('month').toISOString(),
                $lte: monthDate.endOf('month').toISOString(),
            }
        }
    }

    if (labelName?.trim()) {
        positionFilters.comment = { $containsi: labelName.trim() }
    }

    if (positionId) {
        const id = Number(positionId)
        if (!Number.isNaN(id)) {
            positionFilters.id = { $eq: id }
        }
    }

    if (materialType) {
        positionFilters.material_type = { documentId: { $eq: materialType } }
    }

    if (stampId?.trim()) {
        positionFilters.stamp = { number: { $containsi: stampId.trim() } }
    }

    if (materialWidth !== undefined && materialWidth !== null && materialWidth !== '') {
        const width = Number(materialWidth)
        if (!Number.isNaN(width)) {
            positionFilters.calculated = { materialWidth: { $eq: width } }
        }
    }

    if (Object.keys(positionFilters).length > 0) {
        filters.calculation_positions = positionFilters
    }

    return filters
}
